export const classList = [
    { id: '1', name: '1' },
    { id: '2', name: '2' },
    { id: '3', name: '3' },
    { id: '4', name: '4' },
    { id: '5', name: '5' },
    { id: '6', name: '6' },
    { id: '7', name: '7' },
    { id: '8', name: '8' },
    { id: '9', name: '9' },
    { id: '10', name: '10' },
    { id: '11', name: '11' },
    { id: '12', name: '12' }
  ]
  
  export const difficultyLevelList = [
    { id: 'EASY', name: 'EASY' },
    { id: 'MODERATE', name: 'MODERATE' },
    { id: 'DIFFICULT', name: 'DIFFICULT' },
    { id: 'VERY DIFFICULT', name: 'VERY DIFFICULT' }
  ]
  
  export const questionTypeList = [
    { id: 'ASSERTION/REASION', name: 'ASSERTION/REASION' },
    { id: 'MCQ', name: 'MCQ' },
    { id: 'TRUE or FALSE', name: 'TRUE or FALSE' },
    { id: 'Fill in the Blanks', name: 'Fill in the Blanks' }
  ]
  
  export const sortByList = [
    { id: 'LEAST USED', name: 'LEAST USED' },
    { id: 'NEWLY ADDED', name: 'NEWLY ADDED' },
    { id: 'MOST USED', name: 'MOST USED' }
  ]
  